
import { defineComponent, onMounted, reactive } from 'vue'

import NewTable from '@/common/new-components/NewTable/index.vue'
import NewButton from '@/ui-kit/NewButton/index.vue'
import Loader from '@/common/components/UI/Loader/index.vue'
import NewLimit from '@/common/new-components/NewLimit/index.vue'
import NewPagination from '@/common/new-components/NewPagination/index.vue'

import CrmTasksFilters from '@/modules/CrmModule/components/CrmTasksFilters/index.vue'
import TasksRow from '@/modules/CrmModule/components/TasksRow/index.vue'
import CrmUpdateTaskOnCall from '@/modules/CrmModule/components/CrmUpdateTaskOnCall/index.vue'

import { Task, GetTasksParams } from '@/new-services/types/crm'

import crmAPI from '@/new-services/crm.service'

const TABLE_COLUMNS = [
    {
        key: 'id',
        name: '№',
    },
    {
        key: 'invoiceNumber',
        name: 'Номер',
    },
    {
        key: 'waitListType',
        name: 'Тип',
    },
    {
        key: 'reason',
        name: 'Задача',
    },
    {
        key: 'processingStatus',
        name: 'Статус',
    },
    {
        key: 'source',
        name: 'Источник',
    },
    {
        key: 'waitListCreateDate',
        name: 'Дата создания ЛО',
    },
    {
        key: 'clientResponseDate',
        name: 'Дата ответа',
    },
    {
        key: 'attempts',
        name: 'Попытки',
    },
    {
        key: 'actions',
        name: '',
    },
]

export default defineComponent({
    components: {
        CrmTasksFilters,
        TasksRow,
        NewTable,
        NewButton,
        Loader,
        NewLimit,
        NewPagination,
        CrmUpdateTaskOnCall,
    },
    setup() {
        const state = reactive({
            list: [] as Task[],
            is_loading: false,
            is_failed: false,
            filters: {
                invoiceNumber: null as string | null,
                waitListType: null as string | null,
                periodFrom: null as string | null,
                periodTo: null as string | null,
                processingStatusId: null as number | null,
                isCompleted: null as number | null,
                source: null as string | null,
            },
            pagination: {
                page: 1,
                limit: 50,
                total_pages: 1,
                total_items: 20,
            },
        })

        const update_task_on_call_state = reactive({
            is_opened: false,
            task: null as Task | null,
        })

        const onUpdateTaskOnCall = (task: Task) => {
            update_task_on_call_state.task = task
            update_task_on_call_state.is_opened = true
        }

        const onUpdateTaskOnCallCancel = () => {
            update_task_on_call_state.is_opened = false
            update_task_on_call_state.task = null
        }

        const onUpdateTaskOnCallSubmit = () => {
            onUpdateTaskOnCallCancel()
            loadTasks()
        }

        //

        const loadTasks = async () => {
            try {
                state.is_loading = true

                const params: GetTasksParams = {
                    page: state.pagination.page,
                    limit: state.pagination.limit,
                    ...state.filters,
                }

                const response = await crmAPI.getTasks(params)
                state.list = response.data.data

                state.pagination.total_items = response.data.meta.total
                state.pagination.total_pages = response.data.meta.last_page

                state.is_failed = false
            } catch (error) {
                state.is_failed = true
                console.error(error)
            } finally {
                state.is_loading = false
            }
        }

        const onFiltersChanged = (filters: GetTasksParams) => {
            state.pagination.page = 1

            state.filters.invoiceNumber = filters.invoiceNumber
            state.filters.periodFrom = filters.periodFrom
            state.filters.periodTo = filters.periodTo
            state.filters.processingStatusId = filters.processingStatusId
            state.filters.waitListType = filters.waitListType
            state.filters.isCompleted = filters.isCompleted
            state.filters.source = filters.source

            loadTasks()
        }

        const onFiltersReset = () => {
            state.pagination.page = 1

            state.filters.invoiceNumber = null
            state.filters.periodFrom = null
            state.filters.periodTo = null
            state.filters.processingStatusId = null
            state.filters.waitListType = null
            state.filters.isCompleted = null
            state.filters.source = null

            loadTasks()
        }

        const onLimitChange = (new_limit: number) => {
            state.pagination.page = 1
            state.pagination.limit = new_limit
            loadTasks()
        }

        const onChangePage = (new_page: number) => {
            state.pagination.page = new_page
            loadTasks()
        }

        //

        onMounted(loadTasks)

        //

        return {
            state,
            //
            update_task_on_call_state,
            onUpdateTaskOnCall,
            onUpdateTaskOnCallCancel,
            onUpdateTaskOnCallSubmit,
            //
            onFiltersChanged,
            onFiltersReset,
            onLimitChange,
            onChangePage,
            loadTasks,
            //
            TABLE_COLUMNS,
        }
    },
})
